var SDK_URL = '//www.dpfile.com/app/app-m-module-img/weixin/jweixin-1.6.0.js'; //微信JSSDK的URL

var configHostnameMap = [//配置wx的js与域名的映射关系
{
  pattern: /dianping.com$/,
  host: 'cps.dianping.com',
  path: '/weixin/config.js',
  jsonp: false,
  appId: '',
  callback: '',
  crossOrigin: 'anonymous'
}, {
  pattern: /51ping.com$/,
  host: 'tcps.51ping.com',
  path: '/weixin/config.js',
  jsonp: false,
  appId: '',
  callback: '',
  crossOrigin: 'anonymous'
}, {
  pattern: /(.meituan.(com|net))|(maoyan.com)|(jchunuo.com)$/,
  host: 'ihotel.meituan.com/topcube/api/toc',
  path: '/weixin/getConfig',
  jsonp: true,
  appId: 'wxc72f01f43da0083b',
  callback: 'jsonpWXLoader',
  crossOrigin: 'anonymous'
}];
var STATUS = {
  NOT_AUTH: 'not-auth',
  BEING_AUTH: 'being-auth',
  AUTH_SUCCESS: 'auth-success',
  AUTH_FAIL: 'auth-fail'
};
var DEFAULT_URL = window.location.href.replace(window.location.hash, '');

if (!window._MTDPAuth_) {
  window._MTDPAuth_ = {
    state: STATUS.NOT_AUTH,
    callbackQueue: []
  };
}

var queue = window._MTDPAuth_.callbackQueue;

function loadScript(src) {
  var onload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var crossOrigin = arguments.length > 2 ? arguments[2] : undefined;
  var script = document.createElement('script');
  script.src = src;
  script.onload = onload;
  crossOrigin && (script.crossOrigin = crossOrigin);
  document.getElementsByTagName("head")[0].appendChild(script);
}

;

function parseParams(opts, location, _MTDPAuth_) {
  var params = {
    debug: false,
    // 是否开启wx debug
    isJsonp: true
  };

  if (/[\?&]debug:wx($|&)/.test(location.search)) {
    params.debug = true;
  }

  if (opts['beta'] === true) {
    // 用于微信唤起
    params.beta = true;
  }

  if (opts && opts['url']) {
    params.url = opts['url'];
  }

  if (opts && opts.advanced) {
    var advancedConfig = opts.advanced;
    params.host = advancedConfig.hostname;
    params.path = advancedConfig.pathname;
    params.callbackName = advancedConfig.callback || 'jsonpWXLoader';
    params.appId = advancedConfig.appid;
    params.crossOrigin = advancedConfig.crossOrigin;

    if (advancedConfig.jsonp === false) {
      params.isJsonp = advancedConfig.jsonp;
    }
  } else {
    configHostnameMap.forEach(function (item) {
      if (item.pattern.test(location.hostname)) {
        params.host = item.host;
        params.path = item.path;
        params.appId = item.appId;
        params.isJsonp = item.jsonp;
        params.callbackName = item.callback;
        params.crossOrigin = item.crossOrigin;
      }
    });
  }

  return params;
}

function use(callback) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!callback) return;

  if (window._MTDPAuth_.state === STATUS.AUTH_SUCCESS || window._MTDPAuth_.state === STATUS.AUTH_FAIL) {
    return callback(window.wx);
  }

  queue.push(callback);

  if (window._MTDPAuth_.state === STATUS.BEING_AUTH) {
    return;
  }

  window._MTDPAuth_.state = STATUS.BEING_AUTH;

  var _parseParams = parseParams(opts, window.location, window._MTDPAuth_),
      host = _parseParams.host,
      path = _parseParams.path,
      callbackName = _parseParams.callbackName,
      appId = _parseParams.appId,
      isJsonp = _parseParams.isJsonp,
      debug = _parseParams.debug,
      beta = _parseParams.beta,
      crossOrigin = _parseParams.crossOrigin,
      _parseParams$url = _parseParams.url,
      url = _parseParams$url === void 0 ? DEFAULT_URL : _parseParams$url;

  var apis = 'checkJsApi,onMenuShareTimeline,onMenuShareAppMessage,onMenuShareQQ,onMenuShareWeibo,onMenuShareQZone,startRecord,stopRecord,onVoiceRecordEnd,playVoice,pauseVoice,stopVoice,onVoicePlayEnd,uploadVoice,downloadVoice,chooseImage,previewImage,uploadImage,downloadImage,getLocalImgData,translateVoice,getNetworkType,openLocation,getLocation,hideOptionMenu,showOptionMenu,hideMenuItems,showMenuItems,hideAllNonBaseMenuItem,showAllNonBaseMenuItem,closeWindow,scanQRCode,chooseWXPay,openAddress,openProductSpecificView,addCard,chooseCard,openCard,startSearchBeacons,stopSearchBeacons,onSearchBeacons,launchMiniProgram,miniProgram,updateAppMessageShareData,updateTimelineShareData,launchApplication';
  var tagList = 'wx-open-launch-weapp,wx-open-launch-app,wx-open-subscribe,wx-open-audio';
  var configSearch = "?apis=".concat(apis, "&tagList=").concat(tagList, "&url=").concat(encodeURIComponent(url));

  if (debug) {
    configSearch += "&debug=".concat(debug);
  }

  if (beta) {
    configSearch += "&beta=".concat(beta);
  }

  var doTask = function doTask() {
    var doCallback = function doCallback() {
      window._MTDPAuth_.state = STATUS.AUTH_SUCCESS;

      while (queue && queue.length) {
        var cb = queue.shift();
        cb && cb(window.wx);
      }
    };

    if (isJsonp) {
      if (host && path && appId && callbackName) {
        window[callbackName] = function (res) {
          var _res$data = res.data,
              timestamp = _res$data.timestamp,
              signature = _res$data.signature,
              nonceStr = _res$data.nonceStr;
          var config = {
            debug: debug,
            appId: appId,
            timestamp: timestamp,
            signature: signature,
            nonceStr: nonceStr,
            jsApiList: apis.split(','),
            openTagList: tagList.split(',')
          };

          if (beta === true) {
            config['beta'] = true;
          }

          wx.config(config);
          doCallback();
        };

        var href = location.href.split('#')[0];

        var _url = "//".concat(host).concat(path, "?url=").concat(encodeURIComponent(href), "&callback=").concat(callbackName);

        loadScript(_url, function () {
          doCallback();
        }, crossOrigin);
      }
    } else {
      var _url2 = "//".concat(host).concat(path).concat(configSearch);

      loadScript(_url2, function () {
        doCallback();
      }, crossOrigin);
    }
  };

  if (opts.noSDK) {
    doTask();
  } else {
    loadScript(SDK_URL, function () {
      doTask();
    }, 'anonymous');
  }
}

export { use };
export default {
  use: use
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@dp/weixin-js-sdk-loader/es/index.js
// module id = 565
// module chunks = 0